// let pos = null
// window.onpopstate = (event) => {
//   if (event.state && event.state.position) {
//     window.parent.postMessage((!pos || pos > event.state.position) ? -1 : 1, '*')
//     pos = event.state.position
//   }
// }

import Vue from 'vue'
import App from '@/App.vue'
import mixins from '@/mixins'
import router from '@/router'
import store from '@/store'

import '@/lib/axios'
import '@/lib/font'
import '@/lib/bootstrap'
import '@/lib/icons'

Vue.config.productionTip = false

new Vue({
  mixins: [mixins],
  router,
  store,
  render: h => h(App)
}).$mount('#app')
